import React from 'react';
import { Grid, Box } from '@mui/material';

const Confirmation = () => {
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            height="100vh"
            p={{ xs: 2, md: 5 }}
        >
            <Grid item xs={12} sm={6} display="flex" justifyContent="center">
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <Box>
                        <img src="assets/icons/done.svg" alt="verified" />
                    </Box>
                    <Box fontWeight={700} fontSize="18px" color="#797979">
                        Success!
                    </Box>
                    <Box fontWeight={500} fontSize="12.92px" color="#4C4C4C" textAlign="center">
                        Your content creator account is now pending
                    </Box>

                </Box>
            </Grid>
        </Grid>
    );
};

export default Confirmation;
